(function () {
  var PRODUCTION_API_ORIGIN = 'https://api.bureauobscura.com';
  var PROTECTED_CART_HANDOFF_COOKIE = 'bo_protected_cart_pending';
  var PROTECTED_CART_HANDOFF_MAX_AGE_MS = 24 * 60 * 60 * 1000;
  var PROTECTED_CART_RETRY_DELAYS = [750, 2000, 5000, 15000, 30000, 60000];
  var PROTECTED_CART_CHECKOUT_HOSTS = [
    'bureauobscura.com',
    'zdeyyw-te.myshopify.com',
  ];
  var protectedCartRequestSequence = 0;
  var protectedCartRetryTimer = null;
  var protectedCartRequestInFlight = false;
  var protectedCartRequestController = null;
  var protectedCartRequestTimeout = null;
  var protectedCartAccountChanging = false;

  function invalidateProtectedCartRequest() {
    protectedCartRequestSequence += 1;
    if (protectedCartRequestController) protectedCartRequestController.abort();
    protectedCartRequestController = null;
    if (protectedCartRequestTimeout !== null) {
      window.clearTimeout(protectedCartRequestTimeout);
      protectedCartRequestTimeout = null;
    }
    protectedCartRequestInFlight = false;
  }

  function protectedCartEndpoint() {
    if (!document.body ||
        document.body.getAttribute('data-bo-protected-cart-projection') !== 'enabled') {
      return null;
    }
    var configuredOrigin = document.body.getAttribute('data-bo-api-origin');
    if (configuredOrigin !== PRODUCTION_API_ORIGIN) return null;
    return configuredOrigin + '/api/commerce/cart';
  }

  function isDark() {
    return document.documentElement.classList.contains('dark');
  }

  function persistAppearance(dark) {
    var appearance = dark ? 'dark' : 'light';
    try {
      var cookieAttributes = '; Max-Age=31536000; Path=/; SameSite=Lax';
      if (/(^|\.)bureauobscura\.com$/i.test(window.location.hostname)) {
        cookieAttributes += '; Domain=.bureauobscura.com';
      }
      if (window.location.protocol === 'https:') cookieAttributes += '; Secure';
      document.cookie = 'bo_appearance=' + appearance + cookieAttributes;
    } catch (error) {}
    try {
      localStorage.setItem('bo_appearance', appearance);
      localStorage.setItem('bo_dark_mode', dark ? '1' : '0');
    } catch (error) {}
  }

  function syncModeLabels() {
    document.querySelectorAll('[data-bo-mode-toggle]').forEach(function (button) {
      var label = isDark() ? 'Switch to light mode' : 'Switch to dark mode';
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);
    });
  }

  function focusServerMessage() {
    var message = document.querySelector('[data-bo-auto-focus]');
    if (!message || !message.textContent.trim()) return;
    window.requestAnimationFrame(function () {
      message.focus();
    });
  }

  function cookieValue(name) {
    var prefix = name + '=';
    var parts = document.cookie ? document.cookie.split(';') : [];
    for (var index = 0; index < parts.length; index += 1) {
      var part = parts[index].trim();
      if (part.indexOf(prefix) === 0) return part.slice(prefix.length);
    }
    return '';
  }

  function protectedCartHandoffStartedAt() {
    var raw = cookieValue(PROTECTED_CART_HANDOFF_COOKIE);
    if (!/^\d{13}$/.test(raw)) return 0;
    var startedAt = Number(raw);
    var age = Date.now() - startedAt;
    if (!Number.isFinite(startedAt) || age < -60000 ||
        age > PROTECTED_CART_HANDOFF_MAX_AGE_MS) {
      return 0;
    }
    return startedAt;
  }

  function clearProtectedCartHandoff() {
    document.cookie = PROTECTED_CART_HANDOFF_COOKIE +
      '=; Path=/; Max-Age=0; SameSite=Lax; Domain=.bureauobscura.com; Secure';
  }

  function clearProtectedCartRetry() {
    if (protectedCartRetryTimer !== null) {
      window.clearTimeout(protectedCartRetryTimer);
      protectedCartRetryTimer = null;
    }
  }

  function scheduleProtectedCartRetry(attempt) {
    if (protectedCartRetryTimer !== null) return;
    var delay = PROTECTED_CART_RETRY_DELAYS[attempt];
    if (!Number.isFinite(delay)) {
      clearProtectedCartHandoff();
      var cartLink = document.querySelector('[data-bo-cart-link]');
      var cartCount = document.querySelector('[data-bo-cart-count]');
      var nativeCart = cartLink && cartCount
        ? nativeCartState(cartLink, cartCount)
        : null;
      if (nativeCart) showNativeCart(cartLink, cartCount, nativeCart);
      return;
    }
    protectedCartRetryTimer = window.setTimeout(function () {
      protectedCartRetryTimer = null;
      projectProtectedCart(attempt + 1);
    }, delay);
  }

  function nativeCartState(cartLink, cartCount) {
    var nativeItemCount = Number.parseInt(
      cartLink.getAttribute('data-bo-native-cart-count') || '',
      10,
    );
    if (!Number.isSafeInteger(nativeItemCount) || nativeItemCount < 0) return null;
    return {
      itemCount: nativeItemCount,
      url: cartLink.getAttribute('data-bo-native-cart-url') || '',
    };
  }

  function showNativeCart(cartLink, cartCount, nativeCart) {
    cartCount.textContent = '[' + nativeCart.itemCount + ']';
    if (nativeCart.url) cartLink.setAttribute('href', nativeCart.url);
  }

  function showProtectedCartHandoff(cartLink, cartCount) {
    cartCount.textContent = '[1]';
    var fallback = cartLink.getAttribute('data-bo-protected-cart-fallback');
    if (fallback) cartLink.setAttribute('href', fallback);
  }

  function isProtectedCartProjection(packet) {
    if (!packet || typeof packet !== 'object') return false;
    if (packet.item_count !== 1) return false;
    if (typeof packet.checkout_url !== 'string' || !packet.checkout_url) return false;
    if (packet.checkout_url !== packet.checkout_url.trim() ||
        /[\s\u0000-\u001f\u007f]/.test(packet.checkout_url)) return false;
    if (typeof packet.archive_id !== 'string') return false;
    if (typeof packet.designation !== 'string') return false;
    try {
      var checkout = new URL(packet.checkout_url);
      return checkout.protocol === 'https:' &&
        PROTECTED_CART_CHECKOUT_HOSTS.indexOf(checkout.hostname) !== -1 &&
        !checkout.username && !checkout.password && !checkout.port && !checkout.hash &&
        /^\/cart\/c\/[^/\s]+$/.test(checkout.pathname) &&
        checkout.searchParams.getAll('key').length === 1 &&
        Boolean(checkout.searchParams.get('key')) &&
        !/[\s\u0000-\u001f\u007f]/.test(checkout.searchParams.get('key')) &&
        !checkout.searchParams.has('sso') && !checkout.searchParams.has('logged_in');
    } catch (error) {
      return false;
    }
  }

  function isEmptyProtectedCartProjection(packet) {
    return packet && typeof packet === 'object' &&
      packet.item_count === 0 && packet.checkout_url === '' &&
      packet.archive_id === '' && packet.designation === '';
  }

  function projectProtectedCart(attempt) {
    if (protectedCartAccountChanging || document.visibilityState === 'hidden') return;
    var cartLink = document.querySelector('[data-bo-cart-link]');
    var cartCount = document.querySelector('[data-bo-cart-count]');
    if (!cartLink || !cartCount) return;

    var nativeCart = nativeCartState(cartLink, cartCount);
    if (!nativeCart) return;
    if (nativeCart.itemCount > 0) {
      invalidateProtectedCartRequest();
      clearProtectedCartRetry();
      clearProtectedCartHandoff();
      showNativeCart(cartLink, cartCount, nativeCart);
      return;
    }
    var handoffStartedAt = protectedCartHandoffStartedAt();
    if (handoffStartedAt) showProtectedCartHandoff(cartLink, cartCount);
    else showNativeCart(cartLink, cartCount, nativeCart);
    var endpoint = protectedCartEndpoint();
    if (!endpoint || protectedCartRequestInFlight) return;
    protectedCartRequestInFlight = true;
    var requestSequence = ++protectedCartRequestSequence;
    var retryAttempt = Number.isInteger(attempt) && attempt >= 0 ? attempt : 0;
    var controller = new AbortController();
    protectedCartRequestController = controller;
    protectedCartRequestTimeout = window.setTimeout(function () {
      controller.abort();
    }, 15000);

    fetch(endpoint, {
      method: 'GET',
      credentials: 'include',
      cache: 'no-store',
      headers: { Accept: 'application/json' },
      signal: controller.signal,
    })
      .then(function (response) {
        if (requestSequence !== protectedCartRequestSequence) return undefined;
        if (!response.ok) {
          if (response.status === 429 || response.status >= 500) {
            scheduleProtectedCartRetry(retryAttempt);
          } else if (response.status === 401 || response.status === 403) {
            clearProtectedCartRetry();
            clearProtectedCartHandoff();
            showNativeCart(cartLink, cartCount, nativeCart);
          }
          return undefined;
        }
        return response.json();
      })
      .then(function (packet) {
        if (requestSequence !== protectedCartRequestSequence) return;
        if (packet === undefined) return;
        if (isProtectedCartProjection(packet)) {
          clearProtectedCartRetry();
          cartCount.textContent = '[1]';
          cartLink.setAttribute('href', packet.checkout_url);
          return;
        }
        if (!isEmptyProtectedCartProjection(packet)) {
          scheduleProtectedCartRetry(retryAttempt);
          return;
        }
        clearProtectedCartRetry();
        clearProtectedCartHandoff();
        showNativeCart(cartLink, cartCount, nativeCart);
      })
      .catch(function () {
        if (requestSequence !== protectedCartRequestSequence) return;
        scheduleProtectedCartRetry(retryAttempt);
      })
      .finally(function () {
        if (requestSequence === protectedCartRequestSequence) {
          if (protectedCartRequestTimeout !== null) {
            window.clearTimeout(protectedCartRequestTimeout);
            protectedCartRequestTimeout = null;
          }
          protectedCartRequestController = null;
          protectedCartRequestInFlight = false;
        }
      });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-bo-mode-toggle]');
    if (!toggle) return;
    var dark = document.documentElement.classList.toggle('dark');
    persistAppearance(dark);
    syncModeLabels();
  });

  syncModeLabels();
  focusServerMessage();
  var initialCartLink = document.querySelector('[data-bo-cart-link]');
  var initialCartCount = document.querySelector('[data-bo-cart-count]');
  if (initialCartLink && initialCartCount && protectedCartHandoffStartedAt()) {
    var initialNativeCart = nativeCartState(initialCartLink, initialCartCount);
    if (initialNativeCart && initialNativeCart.itemCount > 0) {
      clearProtectedCartHandoff();
      showNativeCart(initialCartLink, initialCartCount, initialNativeCart);
    } else if (initialNativeCart) {
      showProtectedCartHandoff(initialCartLink, initialCartCount);
    }
  }
  window.addEventListener('pageshow', function () {
    projectProtectedCart(0);
  });
  window.addEventListener('focus', function () {
    projectProtectedCart(0);
  });
  window.addEventListener('pagehide', function () {
    invalidateProtectedCartRequest();
    clearProtectedCartRetry();
  });
  window.addEventListener('bureau:account-changing', function () {
    protectedCartAccountChanging = true;
    invalidateProtectedCartRequest();
    clearProtectedCartRetry();
    clearProtectedCartHandoff();
    var cartLink = document.querySelector('[data-bo-cart-link]');
    var cartCount = document.querySelector('[data-bo-cart-count]');
    var nativeCart = cartLink && cartCount ? nativeCartState(cartLink, cartCount) : null;
    if (nativeCart) showNativeCart(cartLink, cartCount, nativeCart);
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      invalidateProtectedCartRequest();
      clearProtectedCartRetry();
      var cartLink = document.querySelector('[data-bo-cart-link]');
      var cartCount = document.querySelector('[data-bo-cart-count]');
      var nativeCart = cartLink && cartCount ? nativeCartState(cartLink, cartCount) : null;
      if (nativeCart) showNativeCart(cartLink, cartCount, nativeCart);
      return;
    }
    projectProtectedCart(0);
  });
})();
